module.exports = __webpack_public_path__ + "media/src/images/icon__magazinQuestion--dark-dd7245b31415894c15d2629f08163d04.svg";